import { MAP_TYPES } from '@deck.gl/carto';

const COUNTY_SOCIOECONOMIC_SOURCE_ID = 'countySocioeconomicSource';

function source(year, socioeconomicFactor) {
  year = parseInt(year);

  return {
    id: COUNTY_SOCIOECONOMIC_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data: `
      SELECT
        ST_X(ST_CENTROID(geom)) AS lng, ST_Y(ST_CENTROID(geom)) AS lat, year, geometry.countyname as countyname, geometry.statename AS statename, ${socioeconomicFactor}
      FROM
        carto-dw-ac-cn5bemsi.shared.county_observations AS observations
      JOIN
        carto-dw-ac-cn5bemsi.shared.county_geometries AS geometry ON observations.CountyName = geometry.countyname AND observations.StateName = geometry.statename
      WHERE
        observations.year = ${year}
    `,
    queryParameters: {
      year,
      socioeconomicFactor,
    },
  };
}

export default source;
